import styled from 'styled-components';

import Preloader from 'components/Preloader';

export default styled(Preloader)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
